$('body').on('click', function(e) {
	let target = $(e.target);

	if ((target.hasClass('header') || target.parents('.header').length)) {
		if ($('.js-intro-animated').length) {
			$('.js-intro-animated').slideUp(1000, () => {
				$('.has-intro-animation').addClass('intro-finished-animating')
			});
		}
	}
});
